import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {MyStorageService} from "../../../services/common/my-storage.service";
import {Constants} from "../../../utils/constants";

@Component({
    selector: 'page-header-restaurant-filter',
    templateUrl: './page-header-restaurant-filter.component.html',
    styleUrls: ['./page-header-restaurant-filter.component.scss']
})
export class PageHeaderRestaurantFilterComponent implements OnChanges {
    @Output() changeEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() actionEvent: EventEmitter<any> = new EventEmitter<any>();
    @Input() cardCategory: string;
    @Input() cardTitle: string;
    @Input() actionTitle: string;
    @Input() withAction: boolean = true;
    @Input() restaurants: any[];

    selectedRestaurantId: any;
    storedRestaurantHistoryId: number;

    constructor(private myStorageService: MyStorageService) {
    }


    ngOnChanges(changes: SimpleChanges): void {
        if (this.restaurants && this.restaurants.length > 0) {
           this.initRestaurantFilter();
        }
    }

    initRestaurantFilter() {
        this.storedRestaurantHistoryId = this.myStorageService.getFromCookies(Constants.RESERVATION_RESTAURANT_HISTORY_ID_KEY, this.restaurants[0].historyId);
        const restaurant = this.restaurants.find(rest => rest.historyId == this.storedRestaurantHistoryId);
        this.changeRestaurant(restaurant);
    }

    action() {
        this.actionEvent.emit();
    }

    changeRestaurant(restaurant: any) {
        this.selectedRestaurantId = restaurant.id;
        this.myStorageService.saveToCookies(Constants.RESERVATION_RESTAURANT_HISTORY_ID_KEY, restaurant.historyId);
        this.changeEvent.emit(restaurant);
    }
}
